import JSBI from 'jsbi'

// exports for external consumption
export type BigintIsh = JSBI | number | string

export enum ChainId {
  ETHEREUM = 1,
  BSC_MAINNET = 56,
  FANTOM = 250,
  POLYGON = 137,
  AVALANCHE = 43114,
  CRONOS = 25,
  BRISE = 32520,
  ARBITRUM = 42161,
  BASE = 8453,
  GOERLI = 5,
  BSC_TESTNET = 97,
  CURTIS = 33111,
  APECHAIN = 33139
}

export enum TradeType {
  EXACT_INPUT,
  EXACT_OUTPUT
}

export enum Rounding {
  ROUND_DOWN,
  ROUND_HALF_UP,
  ROUND_UP
}

export const EXCHANGE_MAP: { [key: number]: { key: string; id: string; name: string }[] } = {
  [ChainId.ETHEREUM]: [{ key: 'uniswap-v2', id: 'uniswap-v2', name: 'Uniswap V2' }],
  [ChainId.ARBITRUM]: [
    { key: 'sushi-v2', id: 'sushi-v2', name: 'SushiSwap' },
    { key: 'camelot', id: 'camelot', name: 'Camelot' }
  ],
  [ChainId.BSC_MAINNET]: [
    { key: 'default', id: 'brewlabs', name: 'BrewSwap' },
    { key: 'pcs-v2', id: 'pcs-v2', name: 'Pancakeswap V2' },
    { key: 'apeswap', id: 'apeswap', name: 'ApeSwap' }
  ],
  [ChainId.FANTOM]: [{ key: 'default', id: 'spookyswap', name: 'Spookyswap V2' }],
  [ChainId.POLYGON]: [
    { key: 'default', id: 'brewlabs', name: 'BrewSwap' },
    { key: 'quickswap', id: 'quickswap', name: 'Quickswap V2' }
  ],
  [ChainId.AVALANCHE]: [{ key: 'default', id: 'tradejoe', name: 'Tradejoe' }],
  [ChainId.CRONOS]: [{ key: 'default', id: 'mmfinance', name: 'MM finance' }],

  [ChainId.GOERLI]: [{ key: 'default', id: 'uniswap-v2', name: 'Uniswap V2' }],
  [ChainId.BSC_TESTNET]: [
    { key: 'brewlabs', id: 'brewlabs', name: 'BrewSwap' },
    { key: 'pcs-v2', id: 'pcs-v2', name: 'Pancakeswap V2' }
  ],
  [ChainId.CURTIS]: [{ key: "brewlabs", id: "brewlabs", name: 'BrewSwap' }],
  [ChainId.APECHAIN]: [{ key: "brewlabs", id: "brewlabs", name: 'BrewSwap' }]
}

export const FACTORY_ADDRESS_MAP: { [key: string]: { [key: number]: string } } = {
  default: {
    [ChainId.ETHEREUM]: '0x5C69bEe701ef814a2B6a3EDD4B1652CB9cc5aA6f', // uniswap-v2
    [ChainId.ARBITRUM]: '0xc35DADB65012eC5796536bD9864eD8773aBc74C4', // sushi factory
    [ChainId.BSC_MAINNET]: '0xFe2bF5fc2D131dB07C5Ef7076856FD7f342738fF', // brewlabs
    [ChainId.FANTOM]: '0x152eE697f2E276fA89E96742e9bB9aB1F2E61bE3', // spookyswap v2 factory
    [ChainId.POLYGON]: '0x563c86d9F17914FF868BCbe3903B3ef829A82F9E', // brewlabs
    [ChainId.AVALANCHE]: '0x9Ad6C38BE94206cA50bb0d90783181662f0Cfa10', // tradejoe factory
    [ChainId.CRONOS]: '0xd590cC180601AEcD6eeADD9B7f2B7611519544f4', // MM finance factory
    [ChainId.BRISE]: '0x9E6d21E759A7A288b80eef94E4737D313D31c13f', // icecream finance factory

    [ChainId.GOERLI]: '0x5C69bEe701ef814a2B6a3EDD4B1652CB9cc5aA6f', // uniswap v2 factory
    [ChainId.BSC_TESTNET]: '0x2fe009ab0E3B2e716B8A0389540767e2567CB67D', // brewlabs
    [ChainId.CURTIS]: '0x7d8c6B58BA2d40FC6E34C25f9A488067Fe0D2dB4',
    [ChainId.APECHAIN]: '0xf61cf68648E6878421ab04654cA6ec38122CA009',

  },
  brewlabs: {
    [ChainId.BSC_MAINNET]: '0xFe2bF5fc2D131dB07C5Ef7076856FD7f342738fF', // brewlabs
    [ChainId.POLYGON]: '0x563c86d9F17914FF868BCbe3903B3ef829A82F9E', // brewlabs
    [ChainId.BSC_TESTNET]: '0x2fe009ab0E3B2e716B8A0389540767e2567CB67D', // brewlabs
    [ChainId.CURTIS]: '0x7d8c6B58BA2d40FC6E34C25f9A488067Fe0D2dB4',
    [ChainId.APECHAIN]: '0xf61cf68648E6878421ab04654cA6ec38122CA009'
  },
  'pcs-v2': {
    [ChainId.BSC_MAINNET]: '0xcA143Ce32Fe78f1f7019d7d551a6402fC5350c73', // pancakeswap v2 factory
    [ChainId.BSC_TESTNET]: '0x6725F303b657a9451d8BA641348b6761A6CC7a17' // pancakeswap v2 factory
  },
  apeswap: {
    [ChainId.BSC_MAINNET]: '0x0841BD0B734E4F5853f0dD8d7Ea041c241fb0Da6' // apeswap factory
  },
  'uniswap-v2': {
    [ChainId.ETHEREUM]: '0x5C69bEe701ef814a2B6a3EDD4B1652CB9cc5aA6f' // uniswap v2 factory
  },
  'sushi-v2': {
    [ChainId.ETHEREUM]: '0xC0AEe478e3658e2610c5F7A4A2E1777cE9e4f2Ac', // sushi factory
    [ChainId.ARBITRUM]: '0xc35DADB65012eC5796536bD9864eD8773aBc74C4' // sushi factory
  },
  quickswap: {
    [ChainId.POLYGON]: '0x5757371414417b8C6CAad45bAeF941aBc7d3Ab32' // quickswap factory
  },
  camelot: {
    [ChainId.ARBITRUM]: '0x6EcCab422D763aC031210895C81787E87B43A652',
    [ChainId.CURTIS]: '0x7d8c6B58BA2d40FC6E34C25f9A488067Fe0D2dB4'
  }
}

export const ROUTER_ADDRESS_MAP = {
  default: {
    [ChainId.ETHEREUM]: '0x7a250d5630B4cF539739dF2C5dAcb4c659F2488D', // uniswap-v2
    [ChainId.ARBITRUM]: '0x1b02dA8Cb0d097eB8D57A175b88c7D8b47997506', // sushi router
    [ChainId.BSC_MAINNET]: '0x5c71e01556b01B6346a4435B145a15aA3A957D23', // brewlabs router
    [ChainId.POLYGON]: '0xE6F1449bC45D19c1D4d761133f8b64D92B8F726E', // brewlabs router
    [ChainId.FANTOM]: '0xF491e7B69E4244ad4002BC14e878a34207E38c29', // spookyswap v2 router
    [ChainId.AVALANCHE]: '0x60aE616a2155Ee3d9A68541Ba4544862310933d4', // tradejoe router
    [ChainId.CRONOS]: '0x145677FC4d9b8F19B5D56d1820c48e0443049a30', // MM finance router
    [ChainId.BRISE]: '0xBb5e1777A331ED93E07cF043363e48d320eb96c4', // icecream finance router

    [ChainId.GOERLI]: '0x7a250d5630B4cF539739dF2C5dAcb4c659F2488D', // uniswap v2 router
    [ChainId.BSC_TESTNET]: '0x4ef7A5C694C6C7a43E1DF09306aC8C6eaDdB3512', // brewlabs router
    [ChainId.CURTIS]: '0x18E621B64d7808c3C47bccbbD7485d23F257D26f',
    [ChainId.APECHAIN]: '0xfeE898415AfD30F5504f00381C3935AD2261b5C7',
  },
  brewlabs: {
    [ChainId.BSC_MAINNET]: '0x5c71e01556b01B6346a4435B145a15aA3A957D23', // brewlabs router
    [ChainId.POLYGON]: '0xE6F1449bC45D19c1D4d761133f8b64D92B8F726E', // brewlabs router
    [ChainId.BSC_TESTNET]: '0x4ef7A5C694C6C7a43E1DF09306aC8C6eaDdB3512', // brewlabs router
    [ChainId.CURTIS]: '0x18E621B64d7808c3C47bccbbD7485d23F257D26f',
    [ChainId.APECHAIN]: '0xfeE898415AfD30F5504f00381C3935AD2261b5C7',
  },
  'pcs-v2': {
    [ChainId.BSC_MAINNET]: '0x10ED43C718714eb63d5aA57B78B54704E256024E', // pancakeswap v2 router
    [ChainId.BSC_TESTNET]: '0xD99D1c33F9fC3444f8101754aBC46c52416550D1' // pancakeswap v2 router
  },
  apeswap: {
    [ChainId.BSC_MAINNET]: '0xcF0feBd3f17CEf5b47b0cD257aCf6025c5BFf3b7' // apeswap router
  },
  'uniswap-v2': {
    [ChainId.ETHEREUM]: '0x7a250d5630B4cF539739dF2C5dAcb4c659F2488D' // uniswap v2 router
  },
  'sushi-v2': {
    [ChainId.ETHEREUM]: '0xd9e1cE17f2641f24aE83637ab66a2cca9C378B9F', // uniswap v2 router
    [ChainId.ARBITRUM]: '0x1b02dA8Cb0d097eB8D57A175b88c7D8b47997506' // sushi router
  },
  quickswap: {
    [ChainId.POLYGON]: '0xa5E0829CaCEd8fFDD4De3c43696c57F7D7A678ff' // quickswap router
  },
  camelot: {
    [ChainId.ARBITRUM]: '0xc873fEcbd354f5A56E00E710B90EF4201db2448d',
    [ChainId.CURTIS]: '0x18E621B64d7808c3C47bccbbD7485d23F257D26f'
  }
}

export const INIT_CODE_HASH_MAP: { [key: string]: { [key: number]: string } } = {
  default: {
    [ChainId.ETHEREUM]: '0x96e8ac4277198ff8b6f785478aa9a39f403cb768dd02cbee326c3e7da348845f', // uniswap v2
    [ChainId.ARBITRUM]: '0xe18a34eb0e04b04f7a0ac29a6e80748dca96319b42c54d679cb821dca90c6303', // sushi v2
    [ChainId.BSC_MAINNET]: '0xa38fb3556278fdf64af8f7de0f4a6502aa106accc92fe440a6d81c86581236a9', // brewlabs
    [ChainId.FANTOM]: '0xcdf2deca40a0bd56de8e3ce5c7df6727e5b1bf2ac96f283fa9c4b3e6b42ea9d2', // spooky swap
    [ChainId.POLYGON]: '0xa38fb3556278fdf64af8f7de0f4a6502aa106accc92fe440a6d81c86581236a9', // brewlabs
    [ChainId.AVALANCHE]: '0x0bbca9af0511ad1a1da383135cf3a8d2ac620e549ef9f6ae3a4c33c2fed0af91', // tradejoe
    [ChainId.CRONOS]: '0x7ae6954210575e79ea2402d23bc6a59c4146a6e6296118aa8b99c747afec8acf', // mm finance
    [ChainId.BRISE]: '0x58c1b429d0ffdb4407396ae8118c58fed54898473076d0394163ea2198f7c4a3', // icecream finance

    [ChainId.GOERLI]: '0x96e8ac4277198ff8b6f785478aa9a39f403cb768dd02cbee326c3e7da348845f', // uniswap v2 init code hash
    [ChainId.BSC_TESTNET]: '0xa38fb3556278fdf64af8f7de0f4a6502aa106accc92fe440a6d81c86581236a9', // brewlabs
    [ChainId.CURTIS]: '0xba70494e4abe6721f3f96552635a28b70921f79b39c6b06ab9cb14618a78df9f',
    [ChainId.APECHAIN]: '0x7af2cd06d86e4252f2c847dae09d1922eb5b0e90a2231ecaf7298d7aaf1f1ccf',
  },
  brewlabs: {
    [ChainId.BSC_MAINNET]: '0xa38fb3556278fdf64af8f7de0f4a6502aa106accc92fe440a6d81c86581236a9', // brewlabs
    [ChainId.POLYGON]: '0xa38fb3556278fdf64af8f7de0f4a6502aa106accc92fe440a6d81c86581236a9', // brewlabs
    [ChainId.BSC_TESTNET]: '0xa38fb3556278fdf64af8f7de0f4a6502aa106accc92fe440a6d81c86581236a9', // brewlabs
    [ChainId.CURTIS]: '0xba70494e4abe6721f3f96552635a28b70921f79b39c6b06ab9cb14618a78df9f',
    [ChainId.APECHAIN]: '0x7af2cd06d86e4252f2c847dae09d1922eb5b0e90a2231ecaf7298d7aaf1f1ccf',
  },
  'pcs-v2': {
    [ChainId.BSC_MAINNET]: '0x00fb7f630766e6a796048ea87d01acd3068e8ff67d078148a3fa3f4a84f69bd5', // pancakeswap v2
    [ChainId.BSC_TESTNET]: '0xd0d4c4cd0848c93cb4fd1f498d7013ee6bfb25783ea21593d5834f5d250ece66' // pancakeswap v2
  },
  apeswap: {
    [ChainId.BSC_MAINNET]: '0xf4ccce374816856d11f00e4069e7cada164065686fbef53c6167a63ec2fd8c5b' // apeswap
  },
  'uniswap-v2': {
    [ChainId.ETHEREUM]: '0x96e8ac4277198ff8b6f785478aa9a39f403cb768dd02cbee326c3e7da348845f' // uniswap v2 init code hash
  },
  'sushi-v2': {
    [ChainId.ETHEREUM]: '0xe18a34eb0e04b04f7a0ac29a6e80748dca96319b42c54d679cb821dca90c6303', // uniswap v2 factory
    [ChainId.ARBITRUM]: '0xe18a34eb0e04b04f7a0ac29a6e80748dca96319b42c54d679cb821dca90c6303' // sushi factory
  },
  quickswap: {
    [ChainId.POLYGON]: '0x96e8ac4277198ff8b6f785478aa9a39f403cb768dd02cbee326c3e7da348845f'
  },
  camelot: {
    [ChainId.ARBITRUM]: '0xa856464ae65f7619087bc369daaf7e387dae1e5af69cfa7935850ebf754b04c1',
    [ChainId.CURTIS]: '0xba70494e4abe6721f3f96552635a28b70921f79b39c6b06ab9cb14618a78df9f',
  }
}

export const PAIR_INFO_MAP: { [key: string]: { [key: number]: { name: string; symbol: string } } } = {
  default: {
    [ChainId.ETHEREUM]: { name: 'Uniswap V2', symbol: 'UNI-V2' }, // uniswap-v2
    [ChainId.ARBITRUM]: { name: 'SushiSwap LP Token', symbol: 'SLP' }, // sushi v2
    [ChainId.BSC_MAINNET]: { name: 'Brewlabs LP', symbol: 'BREWLABS-LP' },
    [ChainId.FANTOM]: { name: 'Spooky LP', symbol: 'spLP' },
    [ChainId.POLYGON]: { name: 'Brewlabs LP', symbol: 'BREWLABS-LP' },
    [ChainId.AVALANCHE]: { name: 'Joe LP Token', symbol: 'JLP' },
    [ChainId.CRONOS]: { name: 'Meerkat LPs', symbol: 'MEERKAT-LP' },
    [ChainId.BRISE]: { name: 'icecreamswap.com LP', symbol: 'ICELP' },

    [ChainId.GOERLI]: { name: 'Uniswap V2', symbol: 'UNI-V2' },
    [ChainId.BSC_TESTNET]: { name: 'Brewlabs LP', symbol: 'BREWLABS-LP' },
    [ChainId.CURTIS]: { name: 'Camelot LP', symbol: 'CMLT-LP' },
    [ChainId.APECHAIN]: { name: 'Ape LPs', symbol: 'APE-LP' }
  },
  brewlabs: {
    [ChainId.BSC_MAINNET]: { name: 'Brewlabs LP', symbol: 'BREWLABS-LP' },
    [ChainId.POLYGON]: { name: 'Brewlabs LP', symbol: 'BREWLABS-LP' },
    [ChainId.BSC_TESTNET]: { name: 'Brewlabs LP', symbol: 'BREWLABS-LP' },
    [ChainId.CURTIS]: { name: 'Camelot LP', symbol: 'CMLT-LP' },
    [ChainId.APECHAIN]: { name: 'Ape LPs', symbol: 'Ape-LP' },
  },
  'pcs-v2': {
    [ChainId.BSC_MAINNET]: { name: 'Pancake LPs', symbol: 'Cake-LP' },
    [ChainId.BSC_TESTNET]: { name: 'Pancake LPs', symbol: 'Cake-LP' }
  },
  apeswap: {
    [ChainId.BSC_MAINNET]: { name: 'ApeSwapFinance LPs', symbol: 'APE-LP' }
  },
  'uniswap-v2': {
    [ChainId.ETHEREUM]: { name: 'Uniswap V2', symbol: 'UNI-V2' }
  },
  'sushi-v2': {
    [ChainId.ETHEREUM]: { name: 'SushiSwap LP Token', symbol: 'SLP' }, // uniswap v2 factory
    [ChainId.ARBITRUM]: { name: 'SushiSwap LP Token', symbol: 'SLP' } // sushi factory
  },
  quickswap: {
    [ChainId.POLYGON]: { name: 'Uniswap V2', symbol: 'UNI-V2' }
  },
  camelot: {
    [ChainId.ARBITRUM]: { name: 'Camelot LP', symbol: 'CMLT-LP' },
    [ChainId.CURTIS]: { name: 'Camelot LP', symbol: 'CMLT-LP' }
  }
}

export const MINIMUM_LIQUIDITY = JSBI.BigInt(1000)

// exports for internal consumption
export const ZERO = JSBI.BigInt(0)
export const ONE = JSBI.BigInt(1)
export const TWO = JSBI.BigInt(2)
export const THREE = JSBI.BigInt(3)
export const FIVE = JSBI.BigInt(5)
export const TEN = JSBI.BigInt(10)
export const _100 = JSBI.BigInt(100)
export const FEES_NUMERATOR = JSBI.BigInt(9975)
export const FEES_DENOMINATOR = JSBI.BigInt(10000)

export enum SolidityType {
  uint8 = 'uint8',
  uint256 = 'uint256'
}

export const SOLIDITY_TYPE_MAXIMA = {
  [SolidityType.uint8]: JSBI.BigInt('0xff'),
  [SolidityType.uint256]: JSBI.BigInt('0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff')
}
